<template>
    <div>
        <div class="searchUser" v-if="this.dadosUsuario.tipo_usuario == 'Administrador'">
            <input type="text" class="mailClient emailUser form-control" v-model="validEmailUser" placeholder="E-Mail do cliente">
            <span
            class="btnSearchUser"
            @click="showUserValid()"
            >Buscar</span>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';
export default {
    mixins: [makeToast],
    data() {
        return {
        validEmailUser: '',
        }
    },

computed: {
    ...mapState([
        'token',
        'dadosUsuario',
        'tipoUsuarios',
    ]),
},

methods: {
    showUserValid() {
        if(this.validEmailUser == '') {
            this.makeToast(
                'Oopss!',
                'Preencha o campo de E-mail',
                'danger'
            );
            return
        }
        const self = this
        self.$store.dispatch('startLoader');
        this.$store
            .dispatch('admin/showClient', this.validEmailUser)
            .then((response) => {
                if(response.data.tipo_usuario_id == 3) {
                    this.$router.push({
                    name: 'administrador-cotacao-lojista',
                    params: { id: response.data.id }
                });
                }
                self.makeToast(
                    'Oopss!',
                    'O usuário não é um lojista!',
                    'danger'
                );
            })
            .catch(() => {
            self.makeToast(
                'Oopss!',
                'Não foi possível encontrar o lojista, tente novamente!',
                'danger'
            );
            });
        self.$store.dispatch('endLoader');
    },
    setCorresponding() {
        if (
        this.dadosUsuario.tipo_usuario === 'Cliente' ||
        this.dadosUsuario.tipo_usuario === 'Profissional'
        ) {
        this.correpondente = 3;
        } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
        this.correpondente = 4;
        }
    },
    getTheIdLista(id) {
        this.idAtualLista = id;
    },
},
}
</script>